// extracted by mini-css-extract-plugin
export var carrierTab = "_5f-0";
export var carrierTabActive = "_5f-1 _5f-0";
export var carrierTabInactive = "_5f-2 _5f-0";
export var carrierTabLabel = "_5f-3";
export var carrierTabLabelActive = "_5f-4 _5f-3";
export var carrierTabLabelInactive = "_5f-5 _5f-3";
export var carrierTabPercentage = "_5f-6";
export var carrierTabPercentageActive = "_5f-7 _5f-6";
export var carrierTabPercentageInactive = "_5f-8 _5f-6";
export var carrierTabWinnable = "_5f-9";
export var carrierTabWinnableActive = "_5f-a _5f-9";
export var carrierTabWinnableInactive = "_5f-b _5f-9";
export var comparisonContainer = "_5f-d";
export var missingRateButton = "_5f-n";
export var missingRateButtonActive = "_5f-o _5f-n";
export var missingRateButtonInactive = "_5f-p _5f-n";
export var missingRateButtonLabel = "_5f-q";
export var missingRateButtonLabelActive = "_5f-r _5f-q";
export var missingRateButtonLabelInactive = "_5f-s _5f-q";
export var sidebar = "_5f-c";
export var strategyButton = "_5f-e";
export var strategyButtonActive = "_5f-f _5f-e";
export var strategyButtonDescription = "_5f-k";
export var strategyButtonDescriptionActive = "_5f-l _5f-k";
export var strategyButtonDescriptionInactive = "_5f-m _5f-k";
export var strategyButtonInactive = "_5f-g _5f-e";
export var strategyButtonLabel = "_5f-h";
export var strategyButtonLabelActive = "_5f-i _5f-h";
export var strategyButtonLabelInactive = "_5f-j _5f-h";
export var unitToggleButton = "_5f-t";
export var unitToggleButtonActive = "_5f-u _5f-t";
export var unitToggleButtonInactive = "_5f-v _5f-t";
export var unitToggleButtonLabel = "_5f-w";
export var unitToggleButtonLabelActive = "_5f-x _5f-w";
export var unitToggleButtonLabelInactive = "_5f-y _5f-w";